import React from 'react';
import { CiGlobe } from 'react-icons/ci';
import { IBLUserProfile } from '@acilearning/ibl-web-react-common';
import './Usermenu.css';
import { getSkillsURL } from '../../hooks/helpers';
import { TbUser } from 'react-icons/tb';

const Usermenu = (props) => {
  const skillsURL = getSkillsURL();
  return (
    <IBLUserProfile
      className={'analytics-user-profil'}
      style={{ minWidth: '50px' }}
      color={'#FFF'}
      backgroundColor={'#21252b'}
      hoverColor={'#383d48'}
      darkMode={true}
      showSettingsMenu={true}
      showProfileMenu={false}
      foranalytics={true}
      additionalDropdowns={[
        {
          icon: <TbUser size={18} color={'#FFF'} />,
          label: 'Profile',
          to: `${skillsURL}${!String(skillsURL).endsWith('/') ? '/' : ''}profile`,
        },
      ]}
    />
  );
};

export default Usermenu;
